import { createEventTracker } from '@zapier/toolbox-tracking';

const trackingFunctions = createEventTracker();

export const { trackEvent } = trackingFunctions;

export default trackingFunctions;
